(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  var applyBtn = document.querySelector("#custom-discount-apply");
  var input = document.querySelector("#custom-discount-input");
  var msg = document.querySelector("#custom-discount-message");
  var removeBtn = document.querySelector("#custom-discount-remove");
  var discountsContainer = document.querySelector("#discounts-container");
  var totalValue = document.querySelector(".totals__total-value");

  if (!msg) return;

  // Function to format money (Shopify returns minor units, so divide by 100)
  function formatMoney(amount, currency) {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: currency || 'AUD'
    }).format(amount / 100);
  }

  // Function to render discounts HTML
  function renderDiscounts(discounts, cartCurrency) {
    if (discounts.length === 0) {
      discountsContainer.innerHTML = '';
      return;
    }

    let html = '<ul class="discounts list-unstyled" role="list" aria-label="Discounts">';
    discounts.forEach(discount => {
      html += `
        <li class="discounts__discount discounts__discount--position">
          <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16" class="icon icon-discount">
            <path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-2C6.47 5 2 9.48 2 14s4.47 9 9.99 9C17.52 23 22 18.52 22 13S17.52 3 8.99 3z"/>
          </svg>
          ${discount.title} (-${formatMoney(discount.total_allocated_amount, cartCurrency || 'AUD')})
          <button id="custom-discount-remove" type="button" style="display:inline-block; margin-left:10px; font-size:14px; color:#cc0000; text-decoration:underline; background:none; border:none; cursor:pointer; padding:0;">Remove</button>
        </li>
      `;
    });
    html += '</ul>';
    discountsContainer.innerHTML = html;
  }

  // Re-attach remove button listener after re-render
  function attachRemoveListener() {
    var newRemoveBtn = document.querySelector("#custom-discount-remove");
    if (newRemoveBtn && !newRemoveBtn.hasAttribute('data-listener')) {
      newRemoveBtn.setAttribute('data-listener', 'true');
      newRemoveBtn.addEventListener("click", removeDiscount);
    }
  }

  // Update UI after success
  function updateUIAfterSuccess(cartData) {
    const discounts = cartData.cart_level_discount_applications || [];
    const newTotal = formatMoney(cartData.total_price, cartData.currency);

    // Update total
    if (totalValue) {
      totalValue.textContent = newTotal;
    }

    // Render discounts
    renderDiscounts(discounts, cartData.currency);

    // Re-attach listener
    attachRemoveListener();

    // Clear message after short delay
    setTimeout(() => {
      if (msg) msg.textContent = '';
    }, 2000);
  }

  // Function to clear discount cookie
  function clearDiscountCookie() {
    const domain = '.{{ shop.domain | escape }}';
    document.cookie = `discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${domain}`;
    document.cookie = 'discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
  }

  // Function to set discount cookie
  function setDiscountCookie(code) {
    const domain = '.{{ shop.domain | escape }}';
    document.cookie = `discount_code=${code}; path=/; domain=${domain}`;
    document.cookie = `discount_code=${code}; path=/;`;
  }

  // Apply discount via AJAX
  if (applyBtn && input) {
    applyBtn.addEventListener("click", function () {
      var code = input.value.trim();

      if (!code) {
        msg.textContent = "Please enter a code.";
        msg.style.color = "red";
        return;
      }

      msg.textContent = "Applying...";
      msg.style.color = "#007bff";

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ discount: code })
      })
      .then(response => {
        console.log('Response status:', response.status);  // Debug
        return response.json().then(data => ({ response, data }));
      })
      .then(({ response, data }) => {
        console.log('Full response data:', data);  // Debug
        let errorMsg = null;

        if (!response.ok || data.status === 422 || data.message === 'Cart Error' || data.errors) {
          errorMsg = data.description || data.message || data.errors?.discount || Object.values(data.errors || {})[0] || "Invalid code. Please try again.";
        } else if (data.cart_level_discount_applications && data.cart_level_discount_applications.length === 0) {
          errorMsg = "Invalid code. Please try again.";
        }

        if (errorMsg) {
          msg.textContent = errorMsg;
          msg.style.color = "red";
        } else {
          setDiscountCookie(code);
          msg.textContent = "Discount applied!";
          msg.style.color = "green";
          input.value = '';
          // Fetch fresh cart and update UI
          fetch('/cart.js')
            .then(res => res.json())
            .then(cartData => updateUIAfterSuccess(cartData))
            .catch(err => console.error('Failed to fetch updated cart:', err));
        }
      })
      .catch(error => {
        console.error('Fetch error:', error);  // Debug
        msg.textContent = "Error applying discount. Please try again.";
        msg.style.color = "red";
      });
    });
  }

  // Remove discount via AJAX
  function removeDiscount() {
    msg.textContent = "Removing...";
    msg.style.color = "#007bff";

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({ discount: "" })
    })
    .then(response => {
      console.log('Remove response status:', response.status);  // Debug
      return response.json().then(data => ({ response, data }));
    })
    .then(({ response, data }) => {
      console.log('Remove full response data:', data);  // Debug
      let errorMsg = null;

      if (!response.ok || data.status === 422 || data.message === 'Cart Error' || data.errors) {
        errorMsg = data.description || data.message || data.errors?.discount || Object.values(data.errors || {})[0] || "Error removing discount. Please try again.";
      } else if (data.cart_level_discount_applications && data.cart_level_discount_applications.length > 0) {
        errorMsg = "Error removing discount. Please try again.";
      }

      if (errorMsg) {
        msg.textContent = errorMsg;
        msg.style.color = "red";
      } else {
        clearDiscountCookie();
        msg.textContent = "Discount removed!";
        msg.style.color = "green";
        // Fetch fresh cart and update UI
        fetch('/cart.js')
          .then(res => res.json())
          .then(cartData => updateUIAfterSuccess(cartData))
          .catch(err => console.error('Failed to fetch updated cart:', err));
      }
    })
    .catch(error => {
      console.error('Remove fetch error:', error);  // Debug
      msg.textContent = "Error removing discount. Please try again.";
      msg.style.color = "red";
    });
  }

  if (removeBtn) {
    removeBtn.addEventListener("click", removeDiscount);
  }
});

  } catch(e) { console.error(e); }
})();
})();
